import React from 'react';
import PropTypes from 'prop-types';
import styles from './AboutBio.module.scss';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';

const image_path = '';

const BioThumbnail = (props) => {
  if (!props.Bio) {
    return null;
  } 

  const image_full_path = props.Bio.photo ? image_path + props.Bio.photo : '';

  return (
    <div className={styles.transparent} onClick={() => props.ThumbnailClick(props.Bio)}>
      <div className={styles.thumbnailContainer}>
        <Avatar 
          alt={props.Bio.name} 
          src={image_full_path} 
          sx={{ width: 56, height: 56, marginRight: 2 }} />
        <div className={styles.singleColumn}>
          <div>
            <Typography variant="h6" className={styles.thumbnailName} gutterBottom>
              {props.Bio.name} 
            </Typography>  
          </div>
          <div>
            <Typography variant="body1" className={styles.thumbnailText} gutterBottom>
              {props.Bio.role} - {props.Bio.affiliation}
            </Typography>      
          </div>
        </div>
      </div>
    </div>
  )
}

BioThumbnail.propTypes = {
  Bio: PropTypes.object.isRequired,
  ThumbnailClick: PropTypes.func,
};

BioThumbnail.defaultProps = {
  ThumbnailClick: () => {},
};

export default BioThumbnail